import React, { Component } from "react";

export default class SetupPageContainer extends Component {
  state = {};
  render() {
    const { children } = this.props;
    return <div className="nc-entity-page-container">{children}</div>;
  }
}
